import { render } from "./giftList.vue?vue&type=template&id=0b7d05f5&scoped=true"
import script from "./giftList.vue?vue&type=script&lang=js"
export * from "./giftList.vue?vue&type=script&lang=js"

import "./giftList.vue?vue&type=style&index=0&id=0b7d05f5&lang=scss&scoped=true"
import "./giftList.vue?vue&type=style&index=1&id=0b7d05f5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7d05f5"]])

export default __exports__